module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "drm",
    attrs: {
      "data-pdf-bookmark": "Copyright Notice",
      "data-type": "preface",
      "epub:type": "preface"
    }
  }, [_c('div', {
    staticClass: "preface",
    attrs: {
      "id": "d13e36"
    }
  }, [_c('h1', {
    staticClass: "ChapTitleNonprintingctnp",
    attrs: {
      "data-displayheader": "no",
      "data-ncx": "yes"
    }
  }, [_vm._v("Copyright Notice")]), _c('p', {
    staticClass: "CopyrightTextdoublespacecrtxd"
  }, [_vm._v("The author and publisher have provided this e-book to you without Digital Rights Management software (DRM) applied so that you can enjoy reading it on your personal devices. This e-book is for your personal use only. You may not print or post this e-book, or make this e-book publicly available in any way. You may not copy, reproduce or upload this e-book, other than to read it on one of your personal devices.")]), _c('p', {
    staticClass: "CopyrightTextdoublespacecrtxd"
  }, [_c('strong', [_vm._v("Copyright infringement is against the law. If you believe the copy of this e-book you are reading infringes on the author's copyright, please notify the publisher at: "), _c('a', {
    attrs: {
      "href": "http://us.macmillanusa.com/piracy",
      "target": "_blank"
    }
  }, [_vm._v("http://us.macmillanusa.com/piracy")]), _vm._v(".")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-546b17fd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface02.vue
// module id = 63
// module chunks = 0